/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Toggle_Forced_Narrative_SubtitlesInputs */



/**
* | output |
* | --- |
* | "Mark selected event(s) as Forced Narrative Subtitles" |
*
* @param {Shortcut_Keys_Desc_Toggle_Forced_Narrative_SubtitlesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_toggle_forced_narrative_subtitles = /** @type {((inputs?: Shortcut_Keys_Desc_Toggle_Forced_Narrative_SubtitlesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Toggle_Forced_Narrative_SubtitlesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Marquer les evenements selectionnes comme sous-titres narratifs forces")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewählte Ereignisse als erzwungene narrative Untertitel markieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Contrassegna gli eventi selezionati come sottotitoli narrativi forzati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отметьте выбранное событие(я) как «Принудительные субтитлы повествования».")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marcar los eventos seleccionados como subtítulos narrativos forzados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将选定的事件标记为强制叙事字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントを強制ナレーション字幕としてマークする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित घटना(ओं) को अनिवार्य कथात्मक उपशीर्षकों के रूप में चिह्नित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Marque o(s) evento(s) selecionado(s) como Legendas Narrativas Forçadas.")
	return /** @type {LocalizedString} */ ("Mark selected event(s) as Forced Narrative Subtitles")
});